import { call, put, takeLatest } from "redux-saga/effects";

import lobbyService from "../../../../services/casino/lobby";
import {
  getGamesStart,
  getGamesSuccess,
  getGamesFailure,
  getGameLinkStart,
  getGameLinkSuccess,
  getGameLinkFailure,
  getSearchedGamesStart,
  getSearchedGamesSuccess,
  getSearchedGamesFailure,
  getTopGamesStart,
  getTopGamesSuccess,
  getTopGamesFailure
} from "../../../redux/casino/lobby/casinoGames";
import { navigateTarget, showErrorMessage } from "../../../redux/toast";

function* casinoGamesWatcher() {
  yield takeLatest(
    [getGamesStart.type, getGameLinkStart.type, getSearchedGamesStart.type],
    casinoGamesWorker
  );
  yield takeLatest(getTopGamesStart.type, casinoGamesWorker);
}

function* casinoGamesWorker(action) {
  try {
    switch (action.type) {
      case getGamesStart.type: {
        const { data, error } = yield lobbyService.getAllGames({
          ...action.payload,
          loadMoreGames: null
        });
        if (!error) {
          yield put(
            getGamesSuccess({
              games: data?.games || [],
              numberOfPages: data?.numberOfPages || 0,
              gamesCount: data?.queriedCount || 0,
              loadMoreGames: action.payload?.loadMoreGames,
              page: action.payload.pageNumber
            })
          );
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getGamesFailure());
        }
        break;
      }

      case getGameLinkStart.type: {
        const { data, error } = yield lobbyService.getGameLink(action.payload);
        if (data?.status === 400) {
          yield put(showErrorMessage({ msg: data?.data || "" }));
          yield put(getGameLinkFailure());
          yield put(navigateTarget(-1));
          break;
        }
        if (data?.status === 503) {
          yield put(showErrorMessage({ msg: data?.error || "" }));
          yield put(getGameLinkFailure());
          yield put(navigateTarget(-1));
          break;
        }
        if (!error) {
          yield put(getGameLinkSuccess(data.data));
        }
        if (error) {
          yield put(showErrorMessage({ msg: error?.message || "" }));
          yield put(getGameLinkFailure());
        }
        break;
      }

      case getSearchedGamesStart.type: {
        const { data, error } = yield lobbyService.getAllSearchedGames({
          ...action.payload,
          loadMoreSeachedGames: null
        });
        if (!error) {
          yield put(
            getSearchedGamesSuccess({
              searchGames: data?.games || [],
              searchNoOfPages: data?.numberOfPages || 0,
              searchCount: data?.queriedCount || 0,
              loadMoreSeachedGames: action.payload?.loadMoreSeachedGames,
              page: action.payload.page
            })
          );
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getSearchedGamesFailure());
        }
        break;
      }
      case getTopGamesStart.type: {
        const { data, error } = yield call(
          lobbyService.getAllTopGames,
          action.payload
        );
        if (data) {
          yield put(
            getTopGamesSuccess({
              topGames: data?.games || [],
              numberOfPagesTopGame: data?.numberOfPages || 0,
              gamesCountTopGames: data?.queriedCount || 0,
              loadMoreTopGame: action.payload?.loadMoreTopGame,
              pageNumber: action.payload.page
            })
          );
        }
        if (error) {
          yield put(showErrorMessage({ msg: error.message }));
          yield put(getTopGamesFailure());
        }
        break;
      }

      default: {
        break;
      }
    }
  } catch (error) {
    switch (action.type) {
      case getGamesStart.type: {
        yield put(getGamesFailure());
        break;
      }
      case getGameLinkStart.type: {
        yield put(getGameLinkFailure());
        break;
      }
      case getSearchedGamesStart.type: {
        yield put(getSearchedGamesFailure());
        break;
      }
      case getTopGamesStart.type: {
        yield put(getTopGamesFailure());
        break;
      }
      default:
        break;
    }
    yield put(showErrorMessage({ msg: error.message }));
  }
}

export default casinoGamesWatcher;
